<template>
  <div class="page-container">
    <a-card title="故障码解释调用日志">
      <!-- 筛选栏 -->
      <a-form layout="inline" :model="filters" style="margin-bottom: 16px">
        <a-form-item label="故障码">
          <a-input
            v-model:value="filters.fault_code"
            placeholder="故障码关键词"
            allow-clear
            style="width: 160px"
            @pressEnter="handleSearch"
          />
        </a-form-item>
        <a-form-item label="状态">
          <a-select
            v-model:value="filters.status"
            placeholder="全部"
            allow-clear
            style="width: 100px"
          >
            <a-select-option value="1">成功</a-select-option>
            <a-select-option value="0">失败</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="时间范围">
          <a-range-picker
            v-model:value="filters.timeRange"
            show-time
            format="YYYY-MM-DD HH:mm"
            style="width: 350px"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="handleSearch">查询</a-button>
          <a-button style="margin-left: 8px" @click="handleReset">重置</a-button>
        </a-form-item>
      </a-form>

      <!-- 表格 -->
      <a-table
        :columns="columns"
        :data-source="list"
        :loading="loading"
        :pagination="pagination"
        row-key="id"
        @change="handleTableChange"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'status'">
            <a-tag :color="record.status === 1 ? 'green' : 'red'">
              {{ record.status === 1 ? '成功' : '失败' }}
            </a-tag>
          </template>
          <template v-if="column.key === 'duration_ms'">
            {{ record.duration_ms != null ? record.duration_ms + ' ms' : '-' }}
          </template>
          <template v-if="column.key === 'action'">
            <a-button type="link" size="small" @click="goDetail(record.id)">
              查看详情
            </a-button>
          </template>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import dayjs from 'dayjs';
import { getFaultCodeExplanationLogs } from '@/api/faultCodeExplanationLog';

const router = useRouter();
const loading = ref(false);
const list = ref([]);

const filters = reactive({
  fault_code: '',
  status: undefined,
  timeRange: null
});

const pagination = reactive({
  current: 1,
  pageSize: 20,
  total: 0,
  showSizeChanger: true,
  showTotal: (total) => `共 ${total} 条`
});

const columns = [
  { title: 'ID', dataIndex: 'id', key: 'id', width: 80 },
  { title: '故障码', dataIndex: 'fault_code', key: 'fault_code', width: 120 },
  { title: '故障描述', dataIndex: 'fault_description', key: 'fault_description', ellipsis: true },
  { title: '模型', dataIndex: 'model_name', key: 'model_name', width: 160 },
  { title: 'Prompt 长度', dataIndex: 'prompt_length', key: 'prompt_length', width: 110 },
  { title: '耗时', key: 'duration_ms', width: 90 },
  { title: '状态', key: 'status', width: 80 },
  { title: '调用时间', dataIndex: 'create_time', key: 'create_time', width: 170 },
  { title: '操作', key: 'action', width: 90 }
];

async function fetchData() {
  loading.value = true;
  try {
    const params = {
      page: pagination.current,
      pageSize: pagination.pageSize,
      call_type: 'fault_code_explanation'
    };
    if (filters.fault_code) params.fault_code = filters.fault_code;
    if (filters.status !== undefined && filters.status !== null) params.status = filters.status;
    if (filters.timeRange && filters.timeRange.length === 2) {
      params.start_time = dayjs(filters.timeRange[0]).format('YYYY-MM-DD HH:mm:ss');
      params.end_time = dayjs(filters.timeRange[1]).format('YYYY-MM-DD HH:mm:ss');
    }
    const res = await getFaultCodeExplanationLogs(params);
    if (res.data) {
      list.value = res.data.items || [];
      pagination.total = res.data.total || 0;
    }
  } finally {
    loading.value = false;
  }
}

function handleSearch() {
  pagination.current = 1;
  fetchData();
}

function handleReset() {
  filters.fault_code = '';
  filters.status = undefined;
  filters.timeRange = null;
  pagination.current = 1;
  fetchData();
}

function handleTableChange(pag) {
  pagination.current = pag.current;
  pagination.pageSize = pag.pageSize;
  fetchData();
}

function goDetail(id) {
  router.push({ name: 'fault-code-explanation-log-detail', params: { id } });
}

onMounted(fetchData);
</script>
